/**
 * 版の呼び名。
 *
 * 版の名前は人が付けるが、**最初の 1 本だけはルールの内部の識別子**
 * （`<ルールの id>_v1`）が入っている。それをそのまま出すと、人には読めない
 * 文字列が「配信中の版」として並ぶ。保存した日時が分かるならそれで呼び、
 * 分からなければ「最初の版」と呼ぶ（**実在する情報だけを使う**）。
 *
 * 詳細の画面と一覧の画面が別々に名前を組み立てていると、片方だけ直っている
 * 状態が生まれる（実際に詳細だけが直り、一覧は識別子のままだった）。
 * 呼び名はここ 1 か所で決める。
 */

/**
 * 版の呼び名を作る。
 *
 * @param ruleId 版が属するルールの id
 * @param promptVersion 版の名前（最初の 1 本は内部の識別子）
 * @param savedAt 保存した時刻。分からなければ `null`（**推測で埋めない**）
 * @param formatDateTime 時刻の書き方。画面と同じものを渡す
 */
export function ruleVersionDisplayName(
  ruleId: string,
  promptVersion: string,
  savedAt: string | null,
  formatDateTime: (value: string) => string,
): string {
  const generated = promptVersion.startsWith(`${ruleId}_v`);
  if (savedAt !== null && savedAt !== "") {
    const at = formatDateTime(savedAt);
    return generated
      ? `最初の版（${at} 保存）`
      : `${promptVersion}（${at} 保存）`;
  }
  return generated ? "最初の版" : promptVersion;
}
